import './contact.less'

import {Maps, Marker} from 'views/maps'

import Blocks from 'views/partials/blocks'
import Button from 'views/layout/button'
import ContactForm from 'forms/contactform'
import ContentContainer from 'views/layout/contentcontainer'
import Layout from 'views/layout'
import Link from 'views/layout/link'
import {MAPS_API_KEY} from 'config'
import Title from 'views/layout/title'
import Wysiwyg from 'views/layout/wysiwyg'
import {WysiwygType} from 'types/types'
import m from 'mithril'
import {t} from 'store'

export type ContactType = {
	name?: string
	address?: string
	postal?: string
	city?: string
	phone?: string
	email?: string
	fax?: string
}
const toPosition = ({latitude, longitude}) => ({
	lat: parseFloat(latitude),
	lng: parseFloat(longitude)
})
export default class Contact extends Layout<{
	form_text?: WysiwygType
	form_title?: string
}> {
	form = new ContactForm()
	isCompleted = false
	errors = []
	getErrors(key: string) {
		return this.errors && this.errors[key]
	}
	view() {
		const {blocks} = this.attrs.data
		return m('.contact', [
			m(ContentContainer, [
				this.infoView(),
				blocks && m('.contact-blocks', m(Blocks, {blocks})),
				this.formView()
			])
		])
	}
	infoView() {
		const {contact} = this.attrs.data
		return m('.contact-info', [
			m('.contact-info-left', [
				m(Title,
					{heading: 2, class: 'contact-info-left-title'},
					contact.name || t('contact.smeunited')
				),
				m('.contact-info-left-address', [
					contact.address &&
						m('.contact-info-left-address-street', contact.address),
					m('.contact-info-left-address-city', [
						contact.postal &&
							m('.contact-info-left-address-city-postal', contact.postal),
						contact.city &&
							m('.contact-info-left-address-city-name', contact.city)
					])
				]),
				contact.phone &&
					m('a.contact-info-left-tel',
						{href: 'tel:' + contact.phone.replace(/\s/g, '')},
						t('contact.tellabel') + contact.phone
					),
				contact.email &&
					m(Link,
						{
							class: 'contact-info-left-email',
							mod: 'mailto',
							href: 'mailto:' + contact.email
						},
						contact.email
					)
			]),
			m('.contact-info-right',
				m(Maps,
					{
						apiKey: MAPS_API_KEY,
						center: {
							lat: 50.84394289999999,
							lng: 4.373086599999965
						},
						disableDefaultUI: true,
						zoom: 14
					},
					m(Marker, {
						position: toPosition({
							latitude: 50.84394289999999,
							longitude: 4.373086599999965
						})
					})
				)
			)
		])
	}
	formView() {
		if (this.isCompleted) {
			return m(ContentContainer,
				m('.contact-thanksmessage', t('contact.thanks'))
			)
		}
		const {form_text, form_title} = this.attrs.data
		return m('form.contact-form',
			{
				onsubmit: e =>
					this.form
						.formSubmit(e)
						.then(_ => (this.isCompleted = true))
						.catch(err => {
							const parsedError = JSON.parse(JSON.stringify(err))
							this.errors = parsedError.response
						})
			},
			[
				m('.contact-form-header', [
					m('.contact-form-header-title', m('h3.title', form_title)),
					m('.contact-form-header-text', m(Wysiwyg, {html: form_text}))
				]),
				m('.contact-form-flex', [
					m('.contact-form-flex-left', [
						this.form.text({
							key: 'name',
							required: true,
							placeholder: t('contact.name'),
							errors: this.getErrors('name')
						}),

						this.form.email({
							key: 'email',
							required: true,
							placeholder: t('contact.email'),
							errors: this.getErrors('email')
						})
					]),
					m('.contact-form-flex-right',
						this.form.textarea({
							key: 'question',
							required: true,
							placeholder: t('contact.question'),
							errors: this.getErrors('question')
						})
					)
				])
			],
			m(Button,
				{
					type: 'button',
					class: 'contact-form-button',
					mod: 'rounded, '
				},
				t('contact.subscribe')
			)
		)
	}
}
